import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
// import { initialFilter } from "./ObjectsUIHelpers";

const ObjectsUIContext = createContext();

export function useObjectsUIContext() {
  return useContext(ObjectsUIContext);
}


export function ObjectsUIProvider({ ObjectsUIEvents, children }) {//,initialFilter
  // const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const [changeFilter, setChangeFilter] = useState(false);

  const value = {
    // queryParams,
    // setQueryParamsBase,
    ids,
    setIds,
    // setQueryParams,
    changeFilter,
    setChangeFilter,
    newObjectButtonClick: ObjectsUIEvents.newObjectButtonClick,
    openEditObjectPage: ObjectsUIEvents.openEditObjectPage,
    openFloorsPage: ObjectsUIEvents.openFloorsPage,
    openRoomsPage: ObjectsUIEvents.openRoomsPage,
    openRefreshObjectDialog: ObjectsUIEvents.openRefreshObjectDialog,
    openAttendenceSettingPage: ObjectsUIEvents.openAttendenceSettingPage,
    openCullinanSettingPage: ObjectsUIEvents.openCullinanSettingPage,
    openDormSettingPage: ObjectsUIEvents.openDormSettingPage,
    openSportSettingPage: ObjectsUIEvents.openSportSettingPage,
    openDeleteObjectDialog: ObjectsUIEvents.openDeleteObjectDialog,
    openDeleteObjectsDialog: ObjectsUIEvents.openDeleteObjectsDialog,
    openHardDeleteObjectsDialog: ObjectsUIEvents.openHardDeleteObjectsDialog,
    openChangePassObjectsDialog: ObjectsUIEvents.openChangePassObjectsDialog,
    openFetchObjectsDialog: ObjectsUIEvents.openFetchObjectsDialog,
    openTransferObjectsDialog: ObjectsUIEvents.openTransferObjectsDialog,
    openUpdateObjectsStatusDialog: ObjectsUIEvents.openUpdateObjectsStatusDialog,
    openAuditOptionDialog: ObjectsUIEvents.openAuditOptionDialog
  };

  return (
    <ObjectsUIContext.Provider value={value}>
      {children}
    </ObjectsUIContext.Provider>
  );
}
